<div mat-dialog-title class="flex-sec">
  <h1 class="bofa--heading is-5">Vendor take action</h1>
  <button mat-button [mat-dialog-close]="true" class="title-btn">
    <span class="hide" role="alert" aria-live="assertive">Vendor take action</span>
    <mat-icon>close</mat-icon> <span class="close">Close</span>
  </button>
</div>

<mat-dialog-content class="dialog-content">
  <mat-card appearance="outlined" class="af-mat-card mat-elevation-z bottom-space">
    <mat-card-content>
      <div class="row">
        <mat-label class="center-align">Applicant Name: {{applicantName}}</mat-label>
        <mat-label class="center-align">Case Number: {{caseNumber}}</mat-label>
      </div>
    </mat-card-content>
  </mat-card>

  <div class="actions row">
    <button type="button" (click)="onWithdrawCase()"
      class="bofa--button secondary medium btn-secondary">Withdraw
    Case</button>
    <mat-form-field class="vc-search-field-width">
      <mat-label>Email</mat-label>
      <input matInput [formControl]="actionEmail">
      <mat-error class="mat-error">Please enter a valid Email address</mat-error>
    </mat-form-field>
    <button type="button" (click)="onUpdateEmailAddress()"
      class="bofa--button secondary medium no-margin-right bottom-space">Update
    Email Address</button>
  </div>

  <mat-card appearance="outlined" class="af-mat-card mat-elevation-z bottom-space top-space">
    <mat-card-content>
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z" matSort>
        <ng-container matColumnDef="templateName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col"> Template Name </th>
          <td mat-cell *matCellDef="let case">{{case.templateName}}</td>
        </ng-container>
        <ng-container matColumnDef="dateSent">
          <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col"> Date/Time Sent </th>
          <td mat-cell *matCellDef="let case"> {{case.dateSent}} </td>
        </ng-container>
        <ng-container matColumnDef="sentTo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col"> To </th>
          <td mat-cell *matCellDef="let case"> {{case.sentTo}} </td>
        </ng-container>
        <ng-container matColumnDef="sentCC">
          <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col"> CC </th>
          <td mat-cell *matCellDef="let case"> {{case.sentCC}} </td>
        </ng-container>
        <ng-container matColumnDef="sentBCC">
          <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col"> BCC </th>
          <td mat-cell *matCellDef="let case"> {{case.sentBCC}} </td>
        </ng-container>
        <ng-container matColumnDef="resend">
          <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col"> Resend </th>
          <td mat-cell *matCellDef="let case">
            <button type="button" (click)="onResendEmail(case.auditId)"
            class="bofa--button secondary no-margin-right medium">Resend</button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      @if (!dataSource.data.length) {
        <div class="no-item">
          No items to display
        </div>
      }
    </mat-card-content>
    <mat-paginator aria-label="Vendor search results take action pagination" [pageSizeOptions]="[3, 1]" showFirstLastButtons></mat-paginator>
  </mat-card>
</mat-dialog-content>
